export const bonuses = [
  {
    number: '01',
    title: 'The 36-Week Counseling Lesson Planner',
    description:
      'Your suggested annual sequence, monthly overviews and flexible scheduling pages. Know what comes next without rebuilding your calendar.',
    image: 'https://cdn.magicpatterns.com/uploads/x23mr6Zxi3G7TwY9Sur2Tw/counselor.webp',
  },
  {
    number: '02',
    title: 'Student Learning Check-In & Reporting Kit',
    description:
      'Six pre/post learning checks with K–2 and grades 3–5 versions, scoring guides and principal-ready summary templates. Document what students understand.',
    image: 'https://cdn.magicpatterns.com/uploads/qr24stM8AAcJtQSU6eRL6w/counselor_2.webp',
  },
  {
    number: '03',
    title: '50 Classroom Check-In & Calm Cards',
    description:
      '25 emotion check-in prompts and 25 calming or help-seeking prompts. Print, choose a card and use the simple instructions.',
    image: 'https://cdn.magicpatterns.com/uploads/totC6iuAi7b29BgksXYSBC/counselor_3.webp',
  },
  {
    number: '04',
    title: 'Small Group Support Starter Kit',
    description:
      '10 short, scripted support sessions covering everyday worries, family changes, loss, anger and changing schools. Educational activities and reflection prompts—not clinical treatment.',
    image: 'https://cdn.magicpatterns.com/uploads/dXoAcw28ZAQTb5MNwx4weA/counselor_4.webp',
  },
  {
    number: '05',
    title: 'Family Connection Newsletter Kit',
    description:
      '12 monthly newsletter templates with skill summaries, caregiver prompts and short home activities. Customize the details instead of writing from scratch.',
    image: 'https://cdn.magicpatterns.com/uploads/1oApGr7SwMYtBAsvk4s3X9/counselor_5.webp',
  },
];
